import React from "react";
import FacebookIcon from "@material-ui/icons/Facebook";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import PhoneIcon from "@material-ui/icons/Phone";
import "../styles/Footer.css";

function Footer() {
  return (
    <div className="footer">
      <div className="socialMedia">
        <a href="https://www.facebook.com/sonam.tomar.7509836?mibextid=ZbWKwL" target={"_blank"} rel="noreferrer">
          <FacebookIcon />
        </a>
        <a href="https://www.linkedin.com/in/sonal-tomar-802307205" target={"_blank"} rel="noreferrer">
          <LinkedInIcon />
        </a>
        <a href="tel:+919119736274" target={"_blank"} rel="noreferrer">
          <PhoneIcon />
        </a>
      </div>
    </div>
  );
}

export default Footer;
